/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import purchaseService from './../../../../services/purchase';
import purchaseTransformer from './../../../../transformers/purchase';
import warehouseService from './../../../../services/warehouse';

export default {
  data() {
    return {
      loading: true,
      tabIndex: 'first',
      currentPurchase:{
        products:[],
        warehouse:{
          name:'',
        },
       supplier: {

        },
        purchaseStatus:{
          name:'',
        },
        stock:{
          name:'',
        }
      },
    };
  },

  computed: {
   
    productList() {
      return this.currentPurchase.products.map(c => ({
        name: c.product.name,
        qty: c.qty,
        purchasePrice: c.purchasePrice,
        costPrice: c.costPrice,
      }));
    },

  },

  watch: {
    currentPurchase: function(currentPurchase){
      console.log(currentPurchase);
    }
  },

  created() {
     this.loading = false;
  },

  methods: {
   
  },
  mounted(){
     Promise.all([
        purchaseService.show(this.$route.params.id),
      ]).then((data) => {
          this.currentPurchase = data[0];
      });
  },
  components: {
    VTable: require('./../../../../components/table/table.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/purchase/receipt/receipt.js